// Detects phone-class browsers only (excludes tablets) so the mobile-mirrored
// UI is served to phones while tablets/desktops keep the existing web app.
const PHONE_UA_REGEX = /iPhone|iPod|Android.*Mobile|BlackBerry|IEMobile|Opera Mini|webOS/i;
const TABLET_UA_REGEX = /iPad|Android(?!.*Mobile)|Tablet/i;

export function isMobilePhoneBrowser() {
  const ua = navigator.userAgent || navigator.vendor || window.opera || '';

  if (TABLET_UA_REGEX.test(ua)) return false;

  // iPadOS 13+ reports as "Macintosh" in desktop mode; touch points distinguish it from a real Mac.
  const isIpadOS13Plus = /Macintosh/i.test(ua) && navigator.maxTouchPoints > 1;
  if (isIpadOS13Plus) return false;

  return PHONE_UA_REGEX.test(ua);
}
